var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSquareRoundTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.1 59H31.8a2.8 2.8 0 0 1-2.8-2.8V23.8a2.8 2.8 0 0 1 2.8-2.8h32.3a2.82 2.82 0 0 1 2.9 2.8V56a3 3 0 0 1-2.9 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 60H31.8a3.8 3.8 0 0 1-3.8-3.8V23.8a3.8 3.8 0 0 1 3.8-3.8h32.3a3.87 3.87 0 0 1 3.9 3.7V56a4 4 0 0 1-3.9 4Zm0-38H31.8a1.79 1.79 0 0 0-1.8 1.8v32.4a1.79 1.79 0 0 0 1.8 1.8h32.3a2 2 0 0 0 2-2V23.8a1.84 1.84 0 0 0-2-1.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m72.3 62.3 1.5-2.1a1 1 0 0 1 1.3-.2l14.3 10.1a1 1 0 0 1 .2 1.3l-1.5 2.1a1 1 0 0 1-1.3.2L72.5 63.6a1 1 0 0 1-.2-1.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 74.9a1.5 1.5 0 0 1-1.1-.4L71.9 64.4a1.93 1.93 0 0 1-.5-2.7l1.5-2.1a1.93 1.93 0 0 1 2.7-.5l14.3 10.1a2 2 0 0 1 .5 2.6l-1.5 2.1a1.82 1.82 0 0 1-1.6 1ZM74.5 60.8 73 62.9 87.3 73l1.5-2Zm14.3 10.1.8.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m76.177 65.857 2.598-3.674 1.551 1.097-2.598 3.674z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 55.6,
    r: 11.6,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68.2a12.6 12.6 0 1 1 7.3-22.9A12.63 12.63 0 0 1 65 68.2ZM65 45a10.6 10.6 0 1 0 10.7 10.5 10.19 10.19 0 0 0-4.6-8.6A9.62 9.62 0 0 0 65 45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 62.8h-3.7l-1.7-4H59a8 8 0 0 0 8-8v-6.7l4 .8v5.8a11.91 11.91 0 0 1-11.9 12.1ZM48 25.2a3.3 3.3 0 1 0 3.3 3.3 3.33 3.33 0 0 0-3.3-3.3Zm0 5.1a1.8 1.8 0 1 1 1.8-1.8 1.79 1.79 0 0 1-1.8 1.8Z"
  })));
};
export default SvgSquareRoundTag;